module.exports = __webpack_public_path__ + "static/media/download.75886c12.svg";